import { appActions } from 'app/app.actions';
import { useAppDispatch } from 'utils/redux/useAppDispatch';

import { TopbarButton } from '../topbarButton';

export const SmsTopbarButton = (): JSX.Element => {
  const dispatch = useAppDispatch();

  const openCompose = (): void => {
    dispatch(
      appActions.showModal({
        modal: {
          type: 'app:composeSms',
        },
      }),
    );
  };

  return (
    <TopbarButton onClick={() => openCompose()} icon="sms" tooltip="New sms" />
  );
};
